import * as React from "react";
import { cn } from "../../lib/cn";

const Input = React.forwardRef(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      `shadow-input flex h-10 w-full rounded-md border border-transparent bg-gray-50 px-3 py-2 text-sm text-black transition placeholder:text-neutral-400 focus:border-neutral-300 focus:bg-white focus:outline-none focus-visible:ring-[2px] focus-visible:ring-neutral-400 disabled:cursor-not-allowed disabled:opacity-50`,
      className
    )}
    ref={ref}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };